module.exports = __webpack_public_path__ + "files/c4d192aa4117a2e9033256bf2334727d.png";